// extracted by mini-css-extract-plugin
module.exports = {"hidden":"pstResult_hidden__aRDv8","textEmphasis":"pstResult_textEmphasis__hLTtG","resultArea":"pstResult_resultArea__I40mG"};